const YOUTUBE_HOST_RE = /(?:youtube\.com|youtu\.be|youtube-nocookie\.com)/i

const URL_IN_TEXT_RE = /(https?:\/\/[^\s<]+[^\s<.,;:!?)\]'"])/gi

/**
 * @param {string} url
 * @returns {string|null}
 */
export function extractYoutubeVideoId(url) {
  if (!url || !YOUTUBE_HOST_RE.test(url)) return null
  try {
    const parsed = new URL(url)
    const host = parsed.hostname.replace(/^www\./, '')

    if (host === 'youtu.be') {
      const id = parsed.pathname.slice(1).split('/')[0]
      return id && /^[\w-]{11}$/.test(id) ? id : null
    }

    if (parsed.pathname.startsWith('/shorts/')) {
      const id = parsed.pathname.split('/')[2]
      return id && /^[\w-]{11}$/.test(id) ? id : null
    }

    if (parsed.pathname.startsWith('/embed/')) {
      const id = parsed.pathname.split('/')[2]
      return id && /^[\w-]{11}$/.test(id) ? id : null
    }

    const v = parsed.searchParams.get('v')
    if (v && /^[\w-]{11}$/.test(v)) return v
  } catch {
    return null
  }
  return null
}

/**
 * @param {string} text
 * @returns {{ videoId: string, url: string }[]}
 */
export function parseYoutubeLinksFromText(text) {
  if (!text) return []
  const seen = new Set()
  const results = []
  const matches = String(text).matchAll(URL_IN_TEXT_RE)
  for (const match of matches) {
    const url = match[1]
    const videoId = extractYoutubeVideoId(url)
    if (!videoId || seen.has(videoId)) continue
    seen.add(videoId)
    results.push({
      videoId,
      url: normalizeYoutubeWatchUrl(videoId, url)
    })
  }
  return results
}

/**
 * @param {string} videoId
 * @param {string} [originalUrl]
 */
export function normalizeYoutubeWatchUrl(videoId, originalUrl) {
  return `https://www.youtube.com/watch?v=${videoId}`
}

export function youtubeThumbnailUrl(videoId, quality = 'hqdefault') {
  return `https://img.youtube.com/vi/${videoId}/${quality}.jpg`
}

/**
 * Remove URLs do YouTube que já terão preview.
 * @param {string} text
 * @param {{ url: string }[]} previews
 */
export function textWithoutYoutubeUrls(text, previews) {
  let out = String(text ?? '')
  for (const { url } of previews) {
    out = out.split(url).join('')
  }
  return out
    .split('\n')
    .map((line) => line.replace(/[^\S\n]+/g, ' ').trim())
    .join('\n')
    .replace(/^\n+|\n+$/g, '')
}
